
const REACT_APP_CONFIG_SUFFIX = process.env.REACT_APP_CONFIG_SUFFIX || "";

export const logoIcon = `${process.env.REACT_APP_OSS_BASE_URL || ""}/statics/images/icon${REACT_APP_CONFIG_SUFFIX}.png`;